import { type ConfirmOptions, useConfirmDialogStore } from '@/shared/stores/confirmDialogStore';

/**
 * Imperative confirm façade — the app's "are you sure?" API, mirroring the
 * `toast` façade. Returns a promise that resolves `true` when the user confirms
 * and `false` on cancel/dismiss. `title`/`description` are plain strings; resolve
 * Lingui `` t`…` `` before calling. The prompt is rendered by the single
 * `<ConfirmDialogHost/>` mounted in `src/routes/__root.tsx`.
 *
 * @example
 *   if (await confirm({ title: t`Sign out?`, variant: 'destructive' })) signOut();
 */
export function confirm(options: ConfirmOptions): Promise<boolean> {
  return new Promise((resolve) => {
    useConfirmDialogStore.getState().request(options, resolve);
  });
}

export type { ConfirmOptions };
